module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-vehicle-slot"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card-n', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 4
    }
  }, [_c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item.vehicle,
      "fieldName": 'vehicle-id'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item.vehicle,
      "fieldName": 'vehicle-brand-and-lot'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item.vehicle,
      "fieldName": 'vehicle-plate'
    },
    slot: "n1"
  }), _c('div', {
    staticClass: "cose",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("Code: " + _vm._s(_vm.item.code))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Source: " + _vm._s(_vm.item.source))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Description: " + _vm._s(_vm.item.description))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Alarm at: " + _vm._s(_vm.item.alarm_at))])]), _c('vehicle-status', {
    attrs: {
      "slot": "n3",
      "item": _vm.item.vehicle,
      "odometer": "odometer"
    },
    slot: "n3"
  }), _c('div', {
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('a', {
    staticClass: "fa fa-globe fa-2x",
    attrs: {
      "href": 'https://maps.google.com/?q=' + _vm.item.position.latitude + ',' + _vm.item.position.longitude,
      "target": "_blank"
    }
  })])], 1)], 1)]) : _vm._e(), (_vm.$is('map')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('card-n', {
    attrs: {
      "showBullets": true,
      "showAction": true,
      "columns": 4
    }
  }, [_c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item.vehicle,
      "fieldName": 'vehicle-id'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item.vehicle,
      "fieldName": 'vehicle-brand-and-lot'
    },
    slot: "n1"
  }), _c('vehicle-fields', {
    attrs: {
      "slot": "n2",
      "item": _vm.item.vehicle,
      "fieldName": 'vehicle-plate'
    },
    slot: "n2"
  }), _c('div', {
    staticClass: "cose",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("Code: " + _vm._s(_vm.item.code) + " " + _vm._s(_vm.item.source))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Description: " + _vm._s(_vm.item.description))])]), _c('div', {
    staticClass: "cose",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("Alarm at: " + _vm._s(_vm.item.alarm_at))])])], 1)], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e47bd6a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Alarm.vue
// module id = 2122
// module chunks = 1